import React from 'react';

function UsageWhite(props) {
  return (
    <svg viewBox="0 0 28 28" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M6 6h16v16H6z" />
        <g transform="translate(7 9)" fill="#FFF" fillRule="nonzero" opacity={0.3}>
          <rect x={3} width={2} height={11} rx={1} />
          <rect y={4} width={2} height={7} rx={1} />
          <rect x={9} y={7} width={2} height={4} rx={1} />
          <rect x={6} y={3} width={2} height={8} rx={1} />
        </g>
        <path
          d="M9.359 17.74a.76.76 0 01-1.11.037.852.852 0 01-.036-1.164l2.946-3.294a.76.76 0 011.083-.063l2.326 2.08 4.03-6.023a.762.762 0 011.103-.136c.34.282.399.8.13 1.157l-4.536 6.694a.762.762 0 01-1.126.116l-2.377-2.125-2.433 2.72z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default UsageWhite;
